// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BAZAAR_RESERVED = "Rezervov\u00e1no";
